// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__AvB7M","title":"Images45_title__3Q3c3","images":"Images45_images__2-nmx"};